import type { MailboxInformation } from '@1js/sydney-types';
import { MailboxType } from '@1js/sydney-types';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isMailboxSharedOrDelegate } from 'owa-account-shared-mailbox-utils';
import {
    isCloudCacheBizchatEnabled,
    getUnifiedInboxResolvedMailboxInfoOrSelf,
} from 'owa-session-store';
import { getCoprincipalAccountForMailboxInfo } from 'owa-account-source-list-store';
import { isCloudCache } from 'owa-account-source-list-internal';

export function requiresMailboxRestriction(mailboxInfo: MailboxInfo | undefined): boolean {
    return getMailboxInformationForAnnotation(mailboxInfo) !== undefined;
}

export function getMailboxInformationForAnnotation(
    mailboxInfo: MailboxInfo | undefined
): MailboxInformation | undefined {
    if (!mailboxInfo) {
        return undefined;
    }

    // If in UIB, check if annotations are required for the mailboxInfo that will be used for bizchat
    const effectiveMailboxInfo = getUnifiedInboxResolvedMailboxInfoOrSelf(mailboxInfo);

    if (
        isGlobalFeatureEnabled('acct-enable-shared-in-bizchat') &&
        (isMailboxSharedOrDelegate(effectiveMailboxInfo) ||
            effectiveMailboxInfo.isExplicitLogon === true)
    ) {
        return {
            mailboxType: MailboxType.SharedMailbox,
            mailboxSmtpAddress: effectiveMailboxInfo.mailboxSmtpAddress,
            auxiliaryMailboxGuid: effectiveMailboxInfo.auxiliaryMailboxGuid ?? undefined,
        };
    }

    if (isCloudCacheBizchatEnabled(effectiveMailboxInfo)) {
        const account = getCoprincipalAccountForMailboxInfo(effectiveMailboxInfo);

        if (account && isCloudCache(account)) {
            return {
                mailboxType: MailboxType.LinkedMailbox,
                mailboxSmtpAddress: account.mailboxInfo.userIdentity,
                auxiliaryMailboxGuid: account.mailboxInfo.auxiliaryMailboxGuid ?? undefined,
            };
        }
    }

    return undefined;
}
